import { Box, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectProps } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SGSSelect.module.scss';

export type OptionType<T = string> = {
    value: T;
    label: string | JSX.Element;
};

export type SGSSelectProps = SelectProps & {
    options: OptionType<string>[];
    helperText?: string;
};

const SGSSelect: React.FC<SGSSelectProps> = ({ children, label, id, name, options, error, helperText, multiple, value, ...props }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    return (
        <FormControl variant={props.variant} error={error}>
            {label && <InputLabel htmlFor={id || name}>{label}</InputLabel>}
            <Select
                {...props}
                id={id || name}
                label={label}
                multiple={multiple}
                // Pour multiple on :
                // - supprime les valeurs contenant undefined
                // (notamment si on ajoute un composant dans la select puisque sinon ça va ajouter ce composant comme option
                // et donc undefined comme value) + de les convertir en string
                // - convertit les valeurs en string
                value={multiple ? (value as string[]).filter((o) => o).map((o) => o.toString()) : value}
                open={open}
                MenuProps={{
                    classes: { list: styles.menu },
                    // Evite que le popover de la select se place dans la select au niveau de l'option cliqué
                    getContentAnchorEl: () => null,
                }}
                onClose={handleClose}
                onOpen={handleOpen}
            >
                {options.map((o) => (
                    <MenuItem key={o.value} value={o.value} classes={{ root: styles.menuItem, selected: styles.menuItem__selected }}>
                        {typeof o.label === 'string' ? t(o.label) : o.label}
                    </MenuItem>
                ))}
                <Box textAlign="center">
                    {multiple && (
                        <Button color="primary" onClick={handleClose} variant="contained">
                            {t('global.ok')}
                        </Button>
                    )}
                </Box>
            </Select>
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
};

export default SGSSelect;
